<template>
  <Head>
    <title>{{ entry.seo.title }}</title>
    <meta property="description" :content="entry.seo.description" />
  </Head>

  <Layout :alerts="entry.alerts">
    <PageIntro :data="entry.pageMasthead"></PageIntro>

    <CardGrid :data="entry.pageComponents.ctaCardGroup[0]"> </CardGrid>

    <Hr />

    <CardGrid :data="entry.pageComponents.ctaCardGroup[1]"> </CardGrid>
  </Layout>
</template>

<script>
import CardGrid from "../../Components/Page-Components/CardGrid.vue";
import Hr from "../../Components/Atoms/Hr.vue";

export default {
  components: {
    CardGrid,
    Hr,
  },

  props: {
    siteUrl: String,
    entry: Object,
  },
};
</script>
